define.alias("shared/components/shared/modal", "calendar/components/shared/modal");